import { useState } from 'react';
import axios from 'axios';
import { mensagemDeErro } from '../../utils/Utils';
import { ImportacaoAnalisada } from '../../telas/importar/logica';

const API_URL = process.env.REACT_APP_API_URL + '/importacoes/analisar';

/**
 * Analisa um PDF (fatura/extrato) no backend. A resposta é uma PRÉVIA —
 * nada é gravado até o usuário confirmar as linhas na tela de revisão.
 */
export function useImportacoes() {
  const [analisando, setAnalisando] = useState(false);

  const analisarPdf = async (
    arquivo: File
  ): Promise<{ analise?: ImportacaoAnalisada; erro?: string }> => {
    const token = localStorage.getItem('token');
    if (!token) return { erro: 'Usuário não autenticado.' };

    setAnalisando(true);
    try {
      const form = new FormData();
      form.append('arquivo', arquivo);
      const resposta = await axios.post<ImportacaoAnalisada>(API_URL, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return { analise: resposta.data };
    } catch (err) {
      return { erro: mensagemDeErro(err) ?? 'Não foi possível analisar o documento. Tente novamente.' };
    } finally {
      setAnalisando(false);
    }
  };

  return { analisando, analisarPdf };
}
